import React from "react";
import "./styles/FilterHeader.scss";

const FilterHeader: React.FC = () => {
  return (
    <header className="filter-header">
      <div className="filter-header__content">
        <h2 className="filter-header__title">
          Show items with value that:
        </h2>
      </div>
    </header>
  );
};

export default FilterHeader;
